import { User } from "react-feather";
import { Col, Row } from "reactstrap";

const ListStafByUnitKerja = ({ data }) => {
  console.log("data", data);
  return (
    <Row className={"justify-content-center p-3"}>
      {data?.stafUnitKerja?.map((row) => (
        <Col sm={3} className={"text-center py-2"}>
          <User />
          <div>{row.nama}</div>
          <div className="d-flex flex-row justify-content-center align-items-center">
            <div>(</div>
            <div>
              <small>{row.role !== "None" ? row.role : "Staf"}</small>
            </div>
            <div>)</div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default ListStafByUnitKerja;
